import type { Reducer } from 'react';
import type { PaintPickerState } from './PaintPickerContext';
import type { PaintProduct } from '../type';
import type { PaintColourProduct } from '@modules/project/api';

export type PaintPickerAction =
    | {
          type: 'TOGGLE_PAINT_PICKER';
          payload: boolean;
      }
    | {
          type: 'TOGGLE_POPULATE_DEFAULT';
          payload: boolean;
      }
    | {
          type: 'SET_PREVIEW_PAINT';
          payload: PaintProduct | null;
      }
    | {
          type: 'SET_PREVIEW_PAINT_MOBILE';
          payload: PaintColourProduct[] | null;
      }
    | { type: 'SET_COLOUR_CACHE'; payload: Map<string, PaintProduct> }
    | { type: 'SET_ACTIVE_IMAGE'; payload: string }
    | { type: 'SET_TOUCH_ENABLED'; payload: boolean };

export const paintPickerReducer: Reducer<
    PaintPickerState,
    PaintPickerAction
> = (state, action) => {
    switch (action.type) {
        case 'TOGGLE_PAINT_PICKER':
            return {
                ...state,
                paintPickerActive: action.payload,
            };
        case 'TOGGLE_POPULATE_DEFAULT':
            return {
                ...state,
                populateDefaults: action.payload,
            };
        case 'SET_PREVIEW_PAINT':
            return {
                ...state,
                previewPaint: action.payload,
            };
        case 'SET_PREVIEW_PAINT_MOBILE':
            const previewPaint = state.previewPaint;
            if (previewPaint && action.payload) {
                const previewWithProduct = action.payload.find(
                    (product) => product.ID === previewPaint.productId
                );

                if (previewWithProduct && previewWithProduct.Link) {
                    previewPaint.link = previewWithProduct.Link;
                    return {
                        ...state,
                        previewPaint: previewPaint,
                    };
                }
            }
            return state;
        case 'SET_COLOUR_CACHE':
            return {
                ...state,
                colourCache: action.payload,
            };
        case 'SET_ACTIVE_IMAGE':
            return {
                ...state,
                activeImageSrc: action.payload,
            };
        case 'SET_TOUCH_ENABLED':
            return {
                ...state,
                touchEnabled: action.payload,
            };
        default:
            throw state;
    }
};
